import React, { useRef } from 'react';
import Bell from './components/Bell';
import Container from './components/Container';
import { useIsOpenedStore, useUnreadCountStore } from './NotificationCenterStore';
import useClickOutsideHandler from '../../layout/navigation-menu/utils/useClickOutsideHandler';
import { useQuery } from '@apollo/client';
import GET_UNREAD_USER_NOTIFICATIONS_COUNT from './queries/getUnreadUserNotificationCountQuery';

const NotificationCenter = () => {
  const notificationsRef = useRef(null);
  const closeNotificationList = useIsOpenedStore.getState().closeNotificationList;
  const setUnreadCount = useUnreadCountStore.getState().setUnreadCount;

  useClickOutsideHandler(notificationsRef, closeNotificationList);

  useQuery(GET_UNREAD_USER_NOTIFICATIONS_COUNT, {
    onCompleted: data => {
      setUnreadCount(data.unreadUserNotificationCount);
    }
  });

  return (
    <div ref={notificationsRef} className='notification'>
      <Bell />
      <Container />
    </div>
  );
};

export default NotificationCenter;
